"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPerformanceColumns = exports.removedPerformanceColumn = exports.updatedPerformanceColumn = exports.addedPerformanceColumn = exports.setPerformanceColumns = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    columns: [],
};
const performanceColumnsSlice = (0, toolkit_1.createSlice)({
    name: 'performanceColumns',
    initialState,
    reducers: {
        setPerformanceColumns: (_state, action) => {
            _state.columns = action.payload ?? [];
        },
        addedPerformanceColumn: (state, action) => {
            state.columns.push(action.payload);
        },
        updatedPerformanceColumn: (state, action) => {
            const index = state.columns.findIndex((column) => column.id === action.payload.id);
            if (index < 0)
                return;
            state.columns[index] = action.payload;
        },
        removedPerformanceColumn: (state, action) => {
            state.columns = state.columns.filter((column) => column.id !== action.payload);
        },
        resetPerformanceColumns: (_state) => {
            return initialState;
        },
    },
});
_a = performanceColumnsSlice.actions, exports.setPerformanceColumns = _a.setPerformanceColumns, exports.addedPerformanceColumn = _a.addedPerformanceColumn, exports.updatedPerformanceColumn = _a.updatedPerformanceColumn, exports.removedPerformanceColumn = _a.removedPerformanceColumn, exports.resetPerformanceColumns = _a.resetPerformanceColumns;
exports.default = performanceColumnsSlice.reducer;
